
import { Button, Alert } from 'element-ui';
import OrderProductCard from './OrderProductCard.vue';
import { OrderHelper } from '@/helpers/OrderHelper';
import { InfoIcon } from 'vue-feather-icons';
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      itemsRetourned: [],
      step: 1,
      error: null,
    };
  },
  computed: {
    currencySign() {
      return this.$localisation.appCurrency.CurrencySign;
    },
    idOrder() {
      return this.order.IdOrder;
    },
    addressDelivery() {
      return this.order.AddressDelivery;
    },
    addressInvoice() {
      return this.order.AddressInvoice;
    },
    dateAdd() {
      return this.order.DateAdd;
    },
    carrierType() {
      return this.order.CarrierType;
    },
    orderQuantity() {
      return this.order.Quantity;
    },
    total() {
      return this.order.TotalPaidTaxIncl;
    },
    products() {
      return this.order.Products;
    },
    showAlertReturnCost() {
      return this.itemsRetourned.some(
        (item) => item?.returnForm?.reasonTypeValue === 0
      );
    },
  },
  methods: {
    onOrderProductCardSelected($event) {
      const { product, returnForm, checked } = $event;

      if (checked) {
        this.itemsRetourned.push({
          product,
          returnForm,
        });
      } else {
        const index = this.itemsRetourned.findIndex(
          (item) => item.product.IdProduct === product.IdProduct
        );

        this.itemsRetourned.splice(index, 1);
      }
    },
    next() {
      let itemHasErrors = null;
      this.itemsRetourned.map((item) => {
        item.returnForm.checkIsValid();

        if (!item.returnForm.valid.state) {
          itemHasErrors = item;
          return;
        }
      });

      if (itemHasErrors === null && this.itemsRetourned.length > 0) {
        this.step = 2;
        if (process.client) {
          window.scrollTo({
            top: this.$refs['orderTop'].offsetTop - 100,
            behavior: 'smooth',
          });
        }
      }
    },
    async onSubmit() {
      this.error = null;
      const orderHelper = new OrderHelper(
        this.$http,
        this.$store,
        this.$i18n.locale
      );

      try {
        const products = this.itemsRetourned.map((item) => {
          const newCombination = item?.returnForm?.variantSelected?.Combination;
          return {
            IdProduct: item.product.IdProduct,
            IdProductAttribute:
              item.product?.Variant?.Combination?.IdProductAttribute,
            Quantity: item.product.Quantity,
            IdOrderDetail: item.product.IdOrderDetail,
            OrderReturnDetailType: item.returnForm.reasonTypeValue,
            OrderReturnReasonCodeValue:
              item.returnForm.resonSelected.OrderReturnReasonCodeValue,
            OrderReturnNewIdProductAttribute: newCombination
              ? newCombination.IdProductAttribute
              : '',
          };
        });

        const productsObject = {};

        productsObject.Products = products;

        try {
          const response = await orderHelper.addReturnProducts({
            idOrder: this.order.IdOrder,
            productsObject,
            languageIsoCode: this.$i18n.locale,
          });
          this.$router.push(
            this.localePath(
              `/account/return/${response.data.IdOrderReturn}/confirmed`
            )
          );
        } catch (error) {
          this.error =
            error?.response?.data?.Message ||
            error?.response?.data?.message ||
            error?.message ||
            this.$t('An error occurred');
        }
      } catch (error) {
        console.log('error', error);
        this.error =
          error?.response?.data?.Message ||
          error?.response?.data?.message ||
          error?.message ||
          this.$t('An error occurred');
      }
    },
  },
  activated() {
    this.step = 1;
  },
  components: { Button, OrderProductCard, InfoIcon, Alert },
};
